import React, { useState } from 'react';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import CommonModal from '../../../../common/Modal';
import { SETUP_LEARN_MORE } from '../../../../../services/Cart/Constants';
import TextLink from '../../../../common/TextLink';
import Button from '../../../../common/Button';
import { getSession } from '../../../../common/Helpers';


export const SetupLearnMoreLink = (props) => {

    const [isModalOpen, setModalOpen] = useState(false);
    const isTgwFlow = getSession('isTGW');
    return (
        <>
        <TextLink
        type="standAlone"
        data-track="true"
        onClick={()=>{ setModalOpen(true)}}
        ariaLabel=  {isTgwFlow && isTgwFlow === 'true' ? "Professional Setup Learn more" : "self setup more info"}
      >
        {SETUP_LEARN_MORE || props.learnMoreHyperlinkText}
      </TextLink>
      <CommonModal 
       opened = {isModalOpen}
       ariaLabel= {isTgwFlow && isTgwFlow === 'true' ? "Professional Setup Learn more" : "self setup more info"}
       onOpenedChange={setModalOpen}
       modalTitle={isTgwFlow && isTgwFlow === 'true' ? parse(props?.learnMoreProfHeaderTGW) : props.learnMoreOverlayTitleText}
       modalBody= {isTgwFlow && isTgwFlow === 'true' ? parse(props?.learnMoreProfModalContentTGW) : props.learnMoreOverlayBodyText}
       modalFooter={<Button onClick={()=>setModalOpen(false)}>Got it</Button>}
       />
      </>);
}

SetupLearnMoreLink.propTypes = {
    learnMoreProfHeaderTGW: PropTypes.string.isRequired,
    learnMoreProfModalContentTGW: PropTypes.string.isRequired,
    learnMoreOverlayTitleText: PropTypes.string.isRequired,
    learnMoreOverlayBodyText: PropTypes.string.isRequired,
    learnMoreHyperlinkText: PropTypes.string.isRequired,
  };